// Module
var code = "<div id=\"V-EBCEBEC3-2DEE-4260-B2B0-383FF759E898\"> <div data-b-component=\"hr\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"> <div> <div data-b-component=\"content\" data-b-comp-content=\"{Binding Content}\" class=\"stretch-content\"> </div> </div> </div> </div> ";
// Exports
export default code;